import { render } from "./AddInitiatorField.vue?vue&type=template&id=4c21ed78"
import script from "./AddInitiatorField.vue?vue&type=script&lang=js"
export * from "./AddInitiatorField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__